import { Directive, ElementRef } from "@angular/core";
import { Field, Scope } from "../base";

export class DropdownPanelScope extends Scope {
    panelContainer = Field<PanelTriggerDirective>();
}

@Directive({ selector: '[panelTrigger]' })
export class PanelTriggerDirective {
    constructor(public el: ElementRef) {}
}
